<app-main-wrap>
  <app-main></app-main>
  <app-footer></app-footer>
</app-main-wrap>
